import { app } from '../../../../app';
import { Controller } from './shared-company-account.controller';

app.component('companySharingCenterSharedAccountsManage', {
    bindings: {
        applicationGroups: '<',
        customGroups: '<',
        sharedAccounts: '<',
    },
    controller: Controller,
    templateUrl: require('./shared-company-account.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-company-account/shared-company-account.component.js